module.controller('walletCtrl', ['$scope', '$state', '$http', '$rootScope', '$window', '$stateParams', 'Session', 'accountService', 'baseURI', 'OVERLAY', function ($scope, $state, $http, $rootScope, $window, $stateParams, Session, accountService, baseURI, OVERLAY){
  var cardUrl = baseURI + 'card/number';
  var cvvUrl = baseURI + 'card/cvv';
  var profileUrl = baseURI + 'cardholder/profile';

  $scope.alert = {};
  $scope.copiedText = "-1";

  $scope.copySuccess = function(e) {
    $scope.copiedText = e.text;
  };

  //check if this is a virtual CH session; do not need to append username in this case.
  if($stateParams.username != Session.getUsername()){
    cardUrl += '?Username=' + $stateParams.username;
    cvvUrl += '?Username=' + $stateParams.username;
  }

  var accounts = accountService.getAccounts() || [];

  var selectedAccount;
  for(var i in accounts){
    if ($stateParams.username === accounts[i].username) {
      selectedAccount = accounts[i];
      break;
    }
  }

  if (selectedAccount && selectedAccount.virtual) {
    // get card number
    $http.get(cardUrl).then(function (resp){
      var data = resp.data;

      if(data.Success){
        $scope.cardNumber = data.Data.CardNumber;
        $scope.expDate = data.Data.ExpDate;
      } else {
        displayError();
      }
    }).catch(function (error){
      displayError();
    });

    // get cvv number
    $http.get(cvvUrl).then(function (resp){
      if(resp.data.Success){
        $scope.cvv = resp.data.Data.CVV;
      } else {
        displayError();
      }
    }).catch(function (error){
      displayError();
    });

    $http.get(profileUrl + '?Username=' + encodeURIComponent($stateParams.username)).then(function (resp){
      $scope.address = {
        PostalCode: resp.data.Data.PostalCode,
      };

      if (resp.data.Data.Address1.indexOf('3611 PAESANOS PKWY') != -1) {
        $scope.showDefaultAddress = true;
      }
    }).catch(function(error){
      console.log('err', error);
    });
  } else {
    $scope.hideCardInfo = true;
  }

  $scope.overlay = OVERLAY['member.home.profile/wallet'];
  $scope.go = function(state) {
    $state.go(state);
  };

  var displayError = function(){
    $scope.alert.alertShown = true;
    $scope.alert.alertMessage = 'Oops, we are having problems retrieving your virtual card. Please try again at a later time.';
  };
}]);
